// Hub page content for the Family & Partner group.
// Sourced from docs/research/australian-visa-pathways.md §3.

const familyPartnerHub = {
  groupSlug: "family-partner",
  eyebrow: "Family & Partner",
  heading: "Family and partner visas",
  intro:
    "Bringing your family to Australia is personal, and the applications are document-heavy and high-stakes. Whether it is a partner, a fiance, a parent, or a child, the outcome rests on genuine, well-organised evidence. We gather and organise that evidence with care, and match you with a registered migration agent who gives the migration advice and lodges the application.",

  howItWorks: {
    heading: "How family visas work",
    steps: [
      {
        title: "Eligibility and relationship",
        detail:
          "A registered migration agent confirms the qualifying relationship and the right subclass for your family.",
      },
      {
        title: "Evidence",
        detail:
          "We gather and organise the relationship, dependency, or sponsorship evidence the case turns on.",
      },
      {
        title: "Application",
        detail:
          "A registered migration agent lodges the application. The Department of Home Affairs decides the outcome.",
      },
      {
        title: "Through to permanent",
        detail:
          "Many family visas have stages, and we keep your matter moving and coordinated all the way to permanent residence.",
      },
    ],
  },

  atAGlance: {
    heading: "Compare the family and partner visas",
    columns: ["Visa", "Best for", "Result", "Sponsor"],
    rows: [
      {
        serviceSlug: "partner-visa",
        cells: [
          "Partner (820/801, 309/100)",
          "Spouses and de facto partners",
          "Two stage, leads to PR",
          "Citizen, PR, or eligible NZ citizen",
        ],
      },
      {
        serviceSlug: "prospective-marriage-300",
        cells: [
          "Prospective Marriage (300)",
          "Fiances planning to marry in Australia",
          "Temporary, leads to partner visa",
          "Citizen, PR, or eligible NZ citizen",
        ],
      },
      {
        serviceSlug: "parent-visa",
        cells: [
          "Parent",
          "Parents of a settled Australian child",
          "Temporary or permanent options",
          "A settled Australian child",
        ],
      },
      {
        serviceSlug: "child-visa",
        cells: [
          "Child",
          "Dependent children of an Australian parent",
          "Permanent residence",
          "Australian parent",
        ],
      },
    ],
  },

  faqs: [
    {
      q: "What matters most in a family visa application?",
      a: "Genuine, well-organised evidence. For partner visas that means proof of a real and continuing relationship. For parent and child visas it means proof of family relationship, dependency, and sponsorship. Gathering and organising this properly is the core of what we do, before a registered migration agent lodges the application.",
    },
    {
      q: "Why do some family visas take so long?",
      a: "Processing times are set by the Department and many family visas, especially parent and partner visas, have long queues. A registered migration agent gives you a realistic, current timeframe for your situation rather than a best-case promise.",
    },
    {
      q: "Can you guarantee my family visa will be approved?",
      a: "No. The Department of Home Affairs decides every application based on the evidence and your circumstances. What we promise is a thorough, well-prepared file and continuity, with the migration advice and lodgement handled by a registered migration agent.",
    },
  ],

  lastVerified: "13 July 2026",
};

export default familyPartnerHub;
